import Result from 'iotera-base/result';
import React, { Component, useEffect, useState } from 'react';
import ReactJsonTree from 'react-json-tree';
import { connect } from 'react-redux';
import { SizeMe } from 'react-sizeme';
import { domainIsTenant as dit } from '../../../../../routes/routes';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import 'bootstrap/dist/css/bootstrap.css';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

import { safeGet, safeGetWithType } from 'iotera-base/json';
import { isInteger, isNone } from 'iotera-base/object';

import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import DateRangeIcon from '@material-ui/icons/DateRange';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';

import '../../../../../lib/components/card/graph_card/style.css';
import '../alternative-style.css';

import { Tooltip, Zoom } from '@material-ui/core';
import Button from '@material-ui/core/Button';

import { buildWBoundActions } from '../../../../../redux/ducks';

import { getWidthColumnByPercent } from '../../../../../lib/components/function';

import {
  CustomTableCell,
  TablePaginationActionsWrapped,
} from '../../../../../custom/table';
import { WEBSERVICE_FETCH } from '../../../../../lib/components/Preference';

// function
import {
  formatDate,
  formatItemStringUObject,
  formatLabelUObject,
  formatValueTable,
  formatValueUObject,
  selectKeyUObject
} from '../function';

import {
  setCallbackGlobal,
  unsetCallbackGlobal,
} from '../../../../../lib/components/callbackGlobal';

// declare golbal variabel tabledatetime
const DEVICE_DATA_RPAYLOAD = 'FETCH_DATA_rpayload';
const DEVICE_DATA_LATEST = 'FETCH_DATA_DATETIME';
const WKEY = 'DEVICE_DATA_DETAIL_DATETIME';
const wBoundActions = buildWBoundActions(WKEY);

// declare global variabel daterangepickercustom
let isFilter;
let filterSelect = '';
let stringFilterSelect = '';
let stringFilter = '';
let labelFilters = '';
let rangesFilter = {};
let getFilterSelect = '';
let startDateCustom = '';
let endDateCustom = '';
let StartDateCustom = '';
let EndDateCustom = '';
let defineStartTime = '';
let defineEndTime = '';
let defineStartDateCustom = '';
let defineEndDateCustom = '';
let formatDateTimeCustom = 'MM/DD/YYYY HH:mm:ss';
let formatDateCustom = 'll';
let formatTimeCustom = 'HH:mm:ss';
let customRangePredefined = true;

class DateRangePickerCustom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stringFilterSelect: '',
      startDateCustomFilter: '',
      endDateCustomFilter: '',
    };
  }

  // arrow function now moment
  nowMoment = () => {
    // get moment now and convert to ms
    const start = moment.utc().subtract(1, 'days').valueOf();
    const end = moment.utc().valueOf();
    StartDateCustom = start;
    EndDateCustom = end;
    // give value for state
    this.setState({
      startDateCustomFilter: start,
      endDateCustomFilter: end,
    });
    // start date and predefined
    startDateCustom = moment(start).format(formatDateTimeCustom);
    defineStartDateCustom = moment(start).format(formatDateCustom);
    defineStartTime = moment(start).format(formatTimeCustom);
    // end date and predefined
    endDateCustom = moment(end).format(formatDateTimeCustom);
    defineEndDateCustom = moment(end).format(formatDateCustom);
    defineEndTime = moment(end).format(formatTimeCustom);
  };

  componentWillMount() {
    const rangeMoment = 1583919478000;
    // get keys from object filterSelect.filter
    getFilterSelect = Object.keys(safeGet(this.filterSelect, 'filter', ''));

    // get values from object filterSelect.filter
    labelFilters = Object.values(safeGet(this.filterSelect, 'filter', ''));

    // declare for increament last moment
    let iMoment = 0;
    // convert array label filter to object save to ranges filter
    rangesFilter = labelFilters.reduce(
      (labelFilter, item) => ({
        ...labelFilter,
        [item.label]: [
          moment.utc(rangeMoment),
          moment.utc(rangeMoment).add(iMoment++, 'd'),
        ],
      }),
      {}
    );
    this.nowMoment();
  }

  handleApply(event, picker) {
    // const buffer = DateRangePickerData
    const momentDateTimeStart = picker.startDate;
    const momentDateTimeEnd = picker.endDate;
    // declare for increment moment select
    let iMomementSelect = 0;
    // selection for custom range or not
    if (moment.utc(momentDateTimeStart).valueOf() === 1583919478000) {
      // looping, selection, and proccess for not custom range/filter select
      for (var i in getFilterSelect) {
        if (
          moment
            .utc(momentDateTimeStart)
            .add(iMomementSelect++, 'd')
            .valueOf() === moment.utc(momentDateTimeEnd).valueOf()
        ) {
          stringFilter = safeGet(
            filterSelect,
            ['filter', getFilterSelect[i], 'label'],
            'Tidak terdefinisi'
          );
          stringFilterSelect = getFilterSelect[i];
          StartDateCustom = '';
          EndDateCustom = '';
          customRangePredefined = false;
        }
        // back to date now
        else {
        }
      }
    }
    // proccess for custom range
    else {
      StartDateCustom = moment.utc(momentDateTimeStart).valueOf();
      EndDateCustom = moment.utc(momentDateTimeEnd).valueOf();

      startDateCustom = moment(StartDateCustom).format(formatDateTimeCustom);
      endDateCustom = moment(EndDateCustom).format(formatDateTimeCustom);
      defineStartTime = moment(StartDateCustom).format(formatTimeCustom);
      defineEndTime = moment(EndDateCustom).format(formatTimeCustom);
      defineStartDateCustom = moment(StartDateCustom).format(formatDateCustom);
      defineEndDateCustom = moment(EndDateCustom).format(formatDateCustom);
      stringFilterSelect = '';
      customRangePredefined = true;
    }
    this.setState({
      stringFilterSelect: stringFilterSelect,
      startDateCustomFilter: StartDateCustom,
      endDateCustomFilter: EndDateCustom,
    });
    this.props.onApply();
  }

  renderPredefined() {
    return (
      <>
        {customRangePredefined == false ? (
          <div type="button" className="iobtn btn-control">
            <div className="d-flex align-items-center">
              <span className="pr-2">
                <DateRangeIcon />
              </span>
              <span className="pr-1">{stringFilter}</span>
              <span className="pr-2">
                <KeyboardArrowDownIcon />
              </span>
            </div>
          </div>
        ) : (
          <div type="button" className="iobtn btn-control">
            <div className="d-flex align-items-center">
              <span className="pr-2">
                <DateRangeIcon />
              </span>
              <span className="text-gray-300 pr-1"> {defineStartTime} </span>
              <span className="pr-1"> {defineStartDateCustom} </span>
              <span className="pl-1 pr-2">
                <ArrowForwardIcon />
              </span>
              <span className="text-gray-300 pr-1"> {defineEndTime}</span>
              <span className="pr-2"> {defineEndDateCustom} </span>
              <span>
                <KeyboardArrowDownIcon />
              </span>
            </div>
          </div>
        )}
      </>
    );
  }

  render() {
    isFilter = safeGet(this.props, 'isFilter', false);
    if (!isFilter) rangesFilter = false;
    return (
      <DateRangePicker
        locale={{ format: formatDateTimeCustom }}
        ranges={rangesFilter}
        linkedCalendars={true}
        opens={'left'}
        startDateCustom={startDateCustom}
        endDateCustom={endDateCustom}
        showDropdowns={true}
        timePicker={true}
        timePicker24Hour={true}
        timePickerSeconds={true}
        onApply={this.handleApply.bind(this)}
      >
        {this.renderPredefined()}
      </DateRangePicker>
    );
  }
}

const TabDateTime = props => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dataUObject, setDataUObject] = useState({});
  const [dialogUObject, setDialogUObject] = useState(false);
  const [selectedKey, setSelectedKey] = useState();

  useEffect(() => {
    const _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeGet(_props, ['match', 'params', 'id']);
    let selected = safeGet(_props, 'selected');
    let sensor = safeGet(selected, 'sensor');
    let configtype = safeGet(selected, 'configtype');
    let param = safeGet(selected, 'param');
    // callback global
    setCallbackGlobal(_props);
    _props.wInitRequestCall({
      wparam: {
        ...domainIsTenant,
        type: WEBSERVICE_FETCH,
        path:
          '/fetch/web/device/periodic/' +
          deviceId +
          '?sensor=' +
          sensor +
          '&configtype=' +
          configtype +
          '&param=' +
          param +
          '&start=' +
          StartDateCustom +
          '&end=' +
          EndDateCustom,
      },
      wcallback: {
        started: function () {
          _props.cbLoading(true);
        },
        finished: function (id, result) {
          if (result.code === Result.HTTP.OK) {
            const responseResult = safeGetWithType(
              result,
              ['body', 'response_result'],
              Result.UNKNOWN_ERROR
            );
            if (responseResult === Result.SUCCESS) {
              setData(safeGetWithType(result, ['body', 'data'], []));
              _props.cbLoading(false);
            } else {
              _props.cbLoading(false);
            }
          } else {
            _props.cbLoading(false);
          }
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  useEffect(() => {
    const _props = props;
    const domainIsTenant = dit(_props);
    let deviceId = safeGet(_props, ['match', 'params', 'id']);
    // callback global
    setCallbackGlobal(_props);
    _props.wSetConfig({
      single_config: {
        [DEVICE_DATA_LATEST]: {
          wparam: {
            ...domainIsTenant,
            type: WEBSERVICE_FETCH,
            path: '/fetch/web/device/periodic/' + deviceId,
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeGetWithType(
                  result,
                  ['body', 'response_result'],
                  Result.UNKNOWN_ERROR
                );
                if (responseResult === Result.SUCCESS) {
                  setData(safeGetWithType(result, ['body', 'data'], []));
                  _props.cbLoading(false);
                } else {
                  _props.cbLoading(false);
                }
              } else {
                _props.cbLoading(false);
              }
            },
          },
          wenv: {
            params: 'date_range',
          },
        },
      },
    });
    return () => {
      // callback global
      unsetCallbackGlobal(_props);
      _props.wUnsetConfig({ key: WKEY });
    };
  }, []);

  const handleExpandNode = () => false;

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage)) rowsPerPage = parseInt(rowsPerPage);
    setPage(0);
    setRowsPerPage(rowsPerPage);
  };

  const handleClickUObject = (i, value) => e => {
    setDataUObject(value);
    setSelectedKey(i);
    setDialogUObject(true);
  };

  const handleCloseUObject = () => {
    setDialogUObject(false);
  };

  const handleApplyDaterange = () => {
    const _props = props;
    let selected = safeGet(_props, 'selected');
    let sensor = safeGet(selected, 'sensor');
    let configtype = safeGet(selected, 'configtype');
    let param = safeGet(selected, 'param');
    _props.wSetEnv({
      type: 'params',
      env: 'date_range',
      value: {
        sensor: sensor,
        configtype: configtype,
        param: param,
        start: StartDateCustom,
        end: EndDateCustom,
      },
    });
    let deviceId = safeGet(_props, ['match', 'params', 'id']);
    _props.cbLoading(true);
    _props.wSingleRequestCall({
      id: DEVICE_DATA_LATEST,
    });
  };

  let subparamDatatypes = safeGet(props, ['selected', 'subparam_datatypes']);
  let _dataUObject = dataUObject;
  if (_dataUObject === null) {
    _dataUObject = {};
  }

  const shouldShowExpandanble = (dt, sdts) => {
    if (dt === 'uobject' || dt === 'image' || dt === 'mobject' || dt === 'surveillance') {
      return true;
    } else if (dt === 'object' && !isNone(sdts)) {
      for (let subparam in sdts) {
        const sdt = safeGet(sdts, subparam)
        if (sdt === 'uobject') {
          return true;
        }
      }
    }
    return false;
  }

  return (
    <div>
      <div className="d-flex justify-content-end">
        <Tooltip
          TransitionComponent={Zoom}
          title="Select datetime"
          enterDelay={500}
        >
          <div>
            <DateRangePickerCustom onApply={handleApplyDaterange} />
          </div>
        </Tooltip>
      </div>
      <SizeMe>
        {({ size }) => (
          <div className="table-responsive mt-4">
            <Table className="table">
              <TableHead style={{ height: 0 }}>
                <TableRow>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(60, size.width - 140),
                      maxWidth: getWidthColumnByPercent(60, size.width - 140),
                    }}
                  >
                    value
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    quality
                  </CustomTableCell>
                  <CustomTableCell
                    style={{
                      minWidth: getWidthColumnByPercent(20, size.width - 140),
                      maxWidth: getWidthColumnByPercent(20, size.width - 140),
                    }}
                  >
                    updated
                  </CustomTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, i) => (
                    <TableRow key={i} className="table-row-child-iotera">
                      <TableCell>
                        {shouldShowExpandanble(item.dt, subparamDatatypes) ? (
                          <Button
                            onClick={handleClickUObject(
                              i,
                              safeGet(item, 'value', {})
                            )}
                          >
                            {' '}
                            {`{...}`}{' '}
                          </Button>
                        ) : (
                          formatValueTable(true, item.dt, item.value, subparamDatatypes)
                        )}
                        {i === selectedKey ? (
                          <Dialog
                            open={dialogUObject}
                            onClose={handleCloseUObject}
                            aria-labelledby="uobject-dialog-title"
                            aria-describedby="uobject-dialog-description"
                            fullWidth={true}
                            maxWidth={'md'}
                          >
                            <DialogTitle id="uobject-dialog-title">
                              {' '}
                              {`${item.sensor}:${item.configtype}:${item.param}`}{' '}
                            </DialogTitle>
                            <DialogContent className="dialog-content-uobject">
                              <ReactJsonTree
                                data={_dataUObject}
                                theme={{
                                  tree: ({ style }) => ({
                                    style: {
                                      ...style,
                                      backgroundColor: undefined,
                                    }, // removing default background color from styles
                                  }),
                                }}
                                getItemString={(
                                  type,
                                  data,
                                  itemType,
                                  itemString
                                ) =>
                                  formatItemStringUObject(
                                    type,
                                    data,
                                    itemType,
                                    itemString
                                  )
                                }
                                keyPath={[selectKeyUObject(item)]}
                                shouldExpandNode={handleExpandNode}
                                labelRenderer={([key]) =>
                                  formatLabelUObject(key)
                                }
                                valueRenderer={value =>
                                  formatValueUObject(value)
                                }
                              />
                            </DialogContent>
                          </Dialog>
                        ) : null}
                      </TableCell>
                      <TableCell>
                        {safeGet(item, ['quality'], '')}
                      </TableCell>
                      <TableCell>
                        <Tooltip
                          title={item.timestamp != null ? item.timestamp : ''}
                          leaveDelay={500}
                          interactive
                        >
                          <span>{formatDate(true, item.timestamp)}</span>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    labelDisplayedRows={({ from, to, count }) =>
                      `${from}-${to} dari ${count}`
                    }
                    labelRowsPerPage="Baris terlihat:"
                    rowsPerPageOptions={[25, 50, 100]}
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    SelectProps={{
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActionsWrapped}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        )}
      </SizeMe>
    </div>
  );
};

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
  };
};

export default connect(null, mapDispatchToProps)(TabDateTime);
